import calendarTypes from "../types/calendarTypes";
import { DateOrderIdentifiers } from "./dateOrders";

export const DateFormatIdentifiers = {
  Long: "Long",
  Medium: "Medium",
  Short: "Short",
  Custom: "Custom"
};

const AbsoluteDateFormatNames = {
  Long: "Long (23 September 1994)",
  Medium: "Medium (23 Sep 1994)",
  Short: "Short (09/23/1994)"
};

const getShortExampleString = dateOrder => {
  let str = "23/09/1994";
  switch (dateOrder) {
    case DateOrderIdentifiers.DayMonthYear:
      str = "23/09/1994";
      break;
    case DateOrderIdentifiers.MonthDayYear:
      str = "09/23/1994";
      break;
    case DateOrderIdentifiers.YearMonthDay:
      str = "1994-09-23";
      break;
    default:
      break;
  }
  return str;
};

const getAbsoluteShortFormatName = dateOrder => {
  return `Short (${getShortExampleString(dateOrder)})`;
};

const RelativeWeekDateFormatNames = {
  Long: "Long (Monday Week 3)",
  Short: "Short (Mon Wk 3)"
};

const RelativeDayDateFormatNames = {
  Long: "Long (Day 4)"
};

export const ThousandSeparatorFormatNames = {
  Comma: "Comma",
  Period: "Period"
};

const DateFormats = {
  [calendarTypes.CALENDAR_TYPE_DATE_TIME]: {
    [DateFormatIdentifiers.Long]: AbsoluteDateFormatNames.Long,
    [DateFormatIdentifiers.Medium]: AbsoluteDateFormatNames.Medium,
    [DateFormatIdentifiers.Short]: AbsoluteDateFormatNames.Short
  },
  [calendarTypes.CALENDAR_TYPE_WEEKDAY_TIME]: {
    [DateFormatIdentifiers.Long]: RelativeWeekDateFormatNames.Long,
    [DateFormatIdentifiers.Short]: RelativeWeekDateFormatNames.Short
  },
  [calendarTypes.CALENDAR_TYPE_DAY_TIME]: {
    [DateFormatIdentifiers.Long]: RelativeDayDateFormatNames.Long
  },
  [calendarTypes.CALENDAR_TYPE_HOUR_TIME]: {
    [DateFormatIdentifiers.Long]: "Time (+2:25:33)"
  }
};

/**
 * Considering the dateOrder
 * @param {number} calendarType Relative or the absolute types
 * @param {string|undefined} dateOrder DateOrderIdentifiers
 */
const getDateFormats = (calendarType, dateOrder) => {
  let formats = DateFormats[calendarType];
  if (calendarType === calendarTypes.CALENDAR_TYPE_DATE_TIME) {
    formats = Object.assign({}, formats);
    formats[DateFormatIdentifiers.Short] = getAbsoluteShortFormatName(dateOrder);
  }
  return formats;
};

export default getDateFormats;
